import './main.scss';

import { startApp } from './app/app';
import { delay } from './app/utils/async';

(async (): Promise<void> => {
  await delay(50);
  await startApp();
})();
